/* liftsets (BUILD-xxxii): barbell plate-loading calculator. Pure client-side maths, no app, no network.
   Target weight - bar - collars, halved per side, then a small dynamic programme (0.25 kg units) finds the
   fewest plates per side from the sizes the lifter ticks. If the exact weight is not reachable it shows the
   nearest loads below and above. Progressive enhancement: the <noscript> block explains the sums by hand. */
(function () {
  'use strict';
  var roots = document.querySelectorAll('[data-ls-plates]');
  if (!roots.length) return;

  function fmt(n) {
    var r = Math.round(n * 100) / 100;
    return (Number.isInteger(r) ? r.toString() : r.toFixed(r * 10 === Math.round(r * 10) ? 1 : 2)).replace(/\.0$/, '');
  }

  // Fewest plates per side for `unitsPerSide` (0.25 kg units) using `sizes` (kg). Returns array of kg or null.
  function solve(unitsPerSide, sizes) {
    var INF = 1e9;
    var best = new Array(unitsPerSide + 1).fill(INF);
    var pick = new Array(unitsPerSide + 1).fill(-1);
    best[0] = 0;
    var units = sizes.map(function (s) { return Math.round(s * 4); });
    for (var w = 1; w <= unitsPerSide; w++) {
      for (var i = 0; i < units.length; i++) {
        var u = units[i];
        if (u <= w && best[w - u] + 1 < best[w]) { best[w] = best[w - u] + 1; pick[w] = i; }
      }
    }
    if (best[unitsPerSide] >= INF) return null;
    var out = [];
    var w2 = unitsPerSide;
    while (w2 > 0) { out.push(sizes[pick[w2]]); w2 -= units[pick[w2]]; }
    return out.sort(function (a, b) { return b - a; });
  }

  function nearest(unitsPerSide, sizes, dir) {
    for (var d = 1; d <= 400; d++) {
      var w = unitsPerSide + dir * d;
      if (w < 0) return null;
      var s = solve(w, sizes);
      if (s) return { units: w, plates: s };
    }
    return null;
  }

  function plateClass(kg) {
    var map = { 25: '25', 20: '20', 15: '15', 10: '10', 5: '5', 2.5: '2_5', 1.25: '1_25' };
    return map[kg] ? 'ls-plates__plate--' + map[kg] : 'ls-plates__plate--small';
  }

  roots.forEach(function (root) {
    var form = root.querySelector('form');
    var target = root.querySelector('[data-ls-target]');
    var barSel = root.querySelector('[data-ls-bar]');
    var barCustom = root.querySelector('[data-ls-bar-custom]');
    var collars = root.querySelector('[data-ls-collars]');
    var out = root.querySelector('[data-ls-result]');
    var boxes = root.querySelectorAll('[data-ls-size]');
    var perSideLabel = root.getAttribute('data-ls-label-side') || 'per side';

    function barWeight() {
      if (barSel.value === 'custom') return parseFloat(barCustom.value) || 0;
      return parseFloat(barSel.value) || 0;
    }

    function render() {
      var t = parseFloat(target.value);
      var bar = barWeight();
      var col = parseFloat(collars && collars.value) || 0;
      var sizes = [];
      boxes.forEach(function (b) { if (b.checked) sizes.push(parseFloat(b.value)); });
      sizes.sort(function (a, b) { return b - a; });
      if (!(t > 0)) { out.innerHTML = '<p class="ls-plates__hint">Enter the total weight you want on the bar.</p>'; return; }
      if (!sizes.length) { out.innerHTML = '<p class="ls-plates__hint">Tick at least one plate size.</p>'; return; }
      var plateTotal = t - bar - col;
      if (plateTotal < 0) { out.innerHTML = '<p class="ls-plates__hint">The bar and collars alone weigh ' + fmt(bar + col) + ' kg, more than the target.</p>'; return; }
      var perSideUnits = Math.round((plateTotal / 2) * 4);
      var exact = Math.abs(perSideUnits / 4 - plateTotal / 2) < 0.001;
      var plates = exact ? solve(perSideUnits, sizes) : null;
      var html = '';
      function draw(list, totalKg, note) {
        var perSide = list.reduce(function (a, b) { return a + b; }, 0);
        html += '<p class="ls-plates__total h4">' + fmt(totalKg) + ' kg on the bar</p>';
        html += '<p class="ls-plates__hint">' + fmt(bar) + ' kg bar' + (col ? ' + ' + fmt(col) + ' kg collars' : '') + ' + ' + fmt(perSide) + ' kg ' + perSideLabel + ' (' + fmt(perSide * 2) + ' kg of plates).' + (note || '') + '</p>';
        html += '<div class="ls-plates__bar" role="img" aria-label="' + (list.length ? list.map(fmt).join(', ') + ' kg plates per side' : 'no plates') + '">';
        html += '<span class="ls-plates__sleeve"></span>';
        list.slice().reverse().forEach(function (kg) { html += '<span class="ls-plates__plate ' + plateClass(kg) + '">' + fmt(kg) + '</span>'; });
        html += '<span class="ls-plates__shaft"></span>';
        list.forEach(function (kg) { html += '<span class="ls-plates__plate ' + plateClass(kg) + '">' + fmt(kg) + '</span>'; });
        html += '<span class="ls-plates__sleeve"></span></div>';
        var counts = {};
        list.forEach(function (kg) { counts[kg] = (counts[kg] || 0) + 1; });
        var keys = Object.keys(counts).map(parseFloat).sort(function (a, b) { return b - a; });
        html += '<ul class="ls-plates__list">';
        if (!keys.length) html += '<li><strong>0</strong> plates: the bar alone</li>';
        keys.forEach(function (kg) { html += '<li><strong>' + counts[kg] + ' × ' + fmt(kg) + ' kg</strong> ' + perSideLabel + ' (' + (counts[kg] * 2) + ' plates in total)</li>'; });
        html += '</ul>';
      }
      if (plates) {
        draw(plates, t, '');
      } else {
        var below = nearest(perSideUnits, sizes, -1);
        var above = nearest(perSideUnits, sizes, 1);
        html += '<div class="ls-plates__warn"><p>' + fmt(t) + ' kg cannot be loaded exactly with those plate sizes. Nearest loads:</p></div>';
        if (below) draw(below.plates, bar + col + below.units / 2, ' (' + fmt(t - (bar + col + below.units / 2)) + ' kg under the target)');
        if (above) draw(above.plates, bar + col + above.units / 2, ' (' + fmt((bar + col + above.units / 2) - t) + ' kg over the target)');
      }
      out.innerHTML = html;
    }

    barSel.addEventListener('change', function () {
      if (barCustom) barCustom.closest('.field').hidden = barSel.value !== 'custom';
      render();
    });
    form.addEventListener('input', render);
    form.addEventListener('submit', function (e) { e.preventDefault(); render(); out.setAttribute('tabindex', '-1'); out.focus({ preventScroll: false }); });
    if (barCustom) barCustom.closest('.field').hidden = barSel.value !== 'custom';
    render();
  });
})();
